export default {"src":"/_next/static/media/pets-no-focus.f35808c8.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};